export function getSegmentActionTrackerKey() {
  return window?.components?.segment_action_tracker;
}

export function getSegmentNonDestinationKey() {
  return window?.components?.segment_action_tracker_non_dest;
}
